/* unplugin-vue-components disabled */import { render } from "./packagingCode.vue?vue&type=template&id=311e40c2"
import script from "./packagingCode.vue?vue&type=script&lang=js"
export * from "./packagingCode.vue?vue&type=script&lang=js"

import "./packagingCode.vue?vue&type=style&index=0&id=311e40c2&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__